import { render, staticRenderFns } from "./PackingTasks.vue?vue&type=template&id=5147cf5e&scoped=true&"
import script from "./PackingTasks.vue?vue&type=script&lang=js&"
export * from "./PackingTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5147cf5e",
  null
  
)

export default component.exports